<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="维度" prop="dimensionType">
                <a-radio-group v-model.number="queryParam.dimensionType" class="full-width-radio-group" button-style="solid">
                  <a-radio-button :value="1"><a-icon type="calendar" />&nbsp;&nbsp;按年</a-radio-button>
                  <a-radio-button :value="2"><a-icon type="calendar" />&nbsp;&nbsp;按月</a-radio-button>
                  <a-radio-button :value="3"><a-icon type="calendar" />&nbsp;&nbsp;按日</a-radio-button>
                  <a-radio-button :value="4"><a-icon type="shop" />&nbsp;&nbsp;按店铺</a-radio-button>
                  <a-radio-button :value="5"><a-icon type="environment" />&nbsp;&nbsp;按省</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-row :gutter="0">
                <a-col :span="8">
                  <a-form-item label="年" prop="year">
                    <a-select v-model="queryParam.year" placeholder="请选择年" style="width: 85%" allow-clear>
                      <a-select-option v-for="item in yearOptions" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="月" prop="month">
                    <a-select v-model="queryParam.month" placeholder="请选择月" style="width: 85%" allow-clear :disabled="!queryParam.year || queryParam.dimensionType === 1">
                      <a-select-option v-for="item in monthOptions" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="日" prop="day">
                    <a-select v-model="queryParam.day" placeholder="请选择日" style="width: 85%" allow-clear :disabled="!queryParam.month || queryParam.dimensionType === 1 ||  queryParam.dimensionType === 2">
                      <a-select-option v-for="item in dayOptions" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="收货省市区" prop="city">
                <a-cascader
                  v-model="selectedCityValue"
                  :options="cityList"
                  change-on-select
                  @change="onCityChange"
                  placeholder="请选择省市区"
                  v-if="cityList"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="dimension"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { queryOpenStatisticsList } from '@/api/played/scriptShopOpen'
import { tableMixin } from '@/store/table-mixin'
import { convertToCascaderFormat } from '@/utils/areaDataConverter'
import { Cascader } from 'ant-design-vue'
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'

export default {
  name: 'ScriptShopOpen',
  components: {
    IndexScriptModal,
    'a-cascader': Cascader
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedCityValue: [], // 用于绑定 cascader 的值
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 年月日选项数据
      yearOptions: [],
      monthOptions: [],
      dayOptions: [],
      // 查询参数
      queryParam: {
        dimensionType: 1,
        year: undefined,
        month: undefined,
        day: undefined,
        shopName: undefined,
        // abbreviation: null,
        // ingot: null,
        // haveTestQualifications: null,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '维度',
          dataIndex: 'dimension',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总订单金额',
          dataIndex: 'totalOrderAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总微信金额',
          dataIndex: 'totalPayPrice',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总使用元宝数',
          dataIndex: 'totalPayIngot',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总消耗优惠券数',
          dataIndex: 'totalCouponCount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总消耗测本券数',
          dataIndex: 'totalTestCount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总开本数',
          dataIndex: 'totalCount',
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.initYearOptions()
    this.initMonthOptions()
    this.getList()
  },
  computed: {
    cityList () {
      const rawData = this.$store.state.user.cityList
      if (rawData && rawData.length > 0) {
        return convertToCascaderFormat(rawData, 3)
      }
      return []
    }
  },
  watch: {
    // 监听年份变化，重新计算月份选项
    'queryParam.year': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initMonthOptions()
          // 重置月份和日期
          this.queryParam.month = undefined
          this.queryParam.day = undefined
          this.dayOptions = []
        }
      }
    },
    // 监听月份变化，重新计算日期选项
    'queryParam.month': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && this.queryParam.year) {
          this.initDayOptions()
          // 重置日期
          this.queryParam.day = undefined
        }
      }
    }
  },
  methods: {
    /** 初始化年份选项 */
    initYearOptions() {
      this.yearOptions = []
      for (let year = 2026; year <= 2030; year++) {
        this.yearOptions.push({
          value: year,
          label: year + '年'
        })
      }
    },

    /** 初始化月份选项 */
    initMonthOptions() {
      this.monthOptions = []
      for (let month = 1; month <= 12; month++) {
        this.monthOptions.push({
          value: month,
          label: month + '月'
        })
      }
    },

    /** 初始化日期选项 */
    initDayOptions() {
      if (!this.queryParam.year || !this.queryParam.month) return

      this.dayOptions = []
      const daysInMonth = new Date(this.queryParam.year, this.queryParam.month, 0).getDate()

      for (let day = 1; day <= daysInMonth; day++) {
        this.dayOptions.push({
          value: day,
          label: day + '日'
        })
      }
    },
    /** 查询银河打本各维度数据汇总看板 */
    getList () {
      this.loading = true
      queryOpenStatisticsList(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        dimensionType: 1,
        year: undefined,
        month: undefined,
        day: undefined,
        shopName: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        pageNum: 1,
        pageSize: 10
      }
      // 重置年月日选项
      this.dayOptions = []
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.shopId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onCityChange(value) {
      this.queryParam.areap = undefined
      this.queryParam.areac = undefined
      this.queryParam.areax = undefined
      if (value) {
        if (value.length > 0) {
          this.queryParam.areap = value[0]
        }
        if (value.length > 1) {
          this.queryParam.areac = value[1]
        }
        if (value.length > 2) {
          this.queryParam.areax = value[2]
        }
      }
    }
  }
}
</script>
